<template>
    <modal :name="modalName" class="admin-account-pair-modal" @beforeOpen="initUsers">
        <div class="modal-title">
            <span v-html="title"></span>
            <img src="../../assets/images/x-icon-grey.svg" alt="X Icon" @click="actionHide">
        </div>
        <div class="user-rows">
            <admin-account-pair-user v-for="user in users" :user="user" v-bind:key="user.id"/>
        </div>
        <text-button label="Pair account" :loading-state="loadingState" @click="actionPair"/>
    </modal>
</template>

<script>
    import Modal from "../components/Modal";
    import AdminAccountPairUser from "./AdminAccountPairUser";
    import TextButton from "../components/TextButton";

    export default {
        name: "AdminAccountPairModal",
        components: {TextButton, AdminAccountPairUser, Modal},
        props: {
            userModel: {
                type: Object,
                required: true,
            },
            platformSlug: {
                type: String,
                required: true,
            },
        },
        computed: {
            modalName() {
                return this.$enums.ModalNameEnum.ADMIN_ACCOUNT_PAIR + '-' + this.platformSlug + '-' + this.userId;
            },
            userId() {
                return this.userModel.id ?? 0;
            },
            userEmail() {
                return this.userModel.email ?? '-';
            },
            title() {
                return '<span>Pair account with e-mail: <b>' + this.userEmail + '</b></span>';
            }
        },
        data() {
            return {
                activeUserId: null,
                users: [],
                loadingState: false,
            }
        },
        methods: {
            actionHide() {
                this.$modals.hide(this.modalName);
            },
            initUsers() {
                this.$api.unpairedAccounts({
                    params: {
                        app: this.platformSlug,
                    }
                }).then(({data}) => {
                    this.users = data;
                    this.activeUserId = this.users[0].id ?? null;
                });
            },
            actionPair() {
                this.loadingState = true;

                this.$api.pairAccountAdmin({
                    data: {
                        app: this.platformSlug,
                        authId: this.userId,
                        oldId: this.activeUserId,
                    }
                }).then(() => {
                    switch (this.platformSlug) {
                        case this.$enums.PlatformSlugEnum.COMPLIANCE:
                            this.$parent.data.compliance = true;
                            break;
                        case this.$enums.PlatformSlugEnum.DFS:
                            this.$parent.data.dfs = true;
                            break;
                        case this.$enums.PlatformSlugEnum.ACADEMY:
                            this.$parent.data.academy = true;
                            break;
                    }
                }).finally(() => {
                    this.loadingState = false;
                    this.actionHide();
                })
            }
        },
    }
</script>

<style lang="scss">
    @import "../scss/variables";

    .admin-account-pair-modal {
        .modal {
            width: 480px;
            background-color: $bg-color-2 !important;
        }
    }

    .user-rows {
        display: grid;
        border-radius: $s-border-radius;
        overflow: hidden;

        .user-row {
            display: flex;
            flex-direction: row;
            align-items: center;
            padding: 0 12px;
            height: 42px;
            border-bottom: solid 1px $bg-color-2;
            box-sizing: border-box;
            background-color: $white-color;
            color: $text-color-2;
            font-weight: lighter;
            font-size: $l-font-size;
            cursor: pointer;
            transition: $transition;

            &:last-child {
                border-bottom: 0;
            }

            & > .circle {
                display: flex;
                justify-content: center;
                align-items: center;
                width: 16px;
                height: 16px;
                border-radius: 50%;
                background-color: $bg-color-2;
                cursor: pointer;

                & > .circle-mark {
                    width: 8px;
                    height: 8px;
                    border-radius: 50%;
                    background-color: $bg-color-2
                }
            }

            & > span {
                margin-left: 12px;
            }

            &:hover:not(.active) {
                & > .circle {
                    & > .circle-mark {
                        background-color: $text-color;
                    }
                }
            }

            &.active {
                & > .circle {
                    & > .circle-mark {
                        background-color: $main-color;
                    }
                }
            }
        }
    }
</style>